class Status  {

    constructor({STATUS}) {
        this.STATUS =  STATUS;
        this.status = {};
        this.IDS = {};
        Object.values(this.STATUS).forEach(value => {
            this.status[value.id] = value.xlat;
            this.IDS[value.name] = value.id;
        });
    }
    
    getIdsFromNumber = (number) => {
        const binaryString = number.toString(2);
        const binaryArray = binaryString.split("");
        const binaryArrayReversed = binaryArray.reverse();
        const ids = this.getIds();
        const idsArray = [];
        binaryArrayReversed.forEach((bit, index) => {
            if (bit === "1") {
                idsArray.push(ids[index]);
            }
        });
        return idsArray;
    };

    getIds = () => [...Object.values(this.STATUS).map(status => status.id)];

    getTranslatedName = (status, id, language) => {
        let lang = language.substring(0,2);
        if (lang !== 'es' && lang!== 'en') { lang = 'en'; }
        return [status[id][lang].name]
    };

    getTranslatedNameFromNumber = (status, number, language) => {
        const ids = this.getIdsFromNumber(number);
        console.log(ids);
        const names = ids.map(id => this.getTranslatedName(status, id, language));
        return names;
    };

    isValidId = (id) => {
        const ids = this.getIds();
        for(let i = 0; i < ids.length; i++) {
            if(Number.parseInt(id) === Number.parseInt(ids[i])) { return true; }
        }
        return false;
    };

    getId = (name) => {
        return this.IDS[name.toLowerCase()];
    };

    getLabel = (id) => {
        for (const tag in this.IDS) {
            if (parseInt(id) === this.IDS[tag]) { return tag; }
        }
    };
};

export default Status;